// Global imperative toast — use anywhere as a drop-in for alert()
// showToast('message')           → auto-detects type from emoji/text
// showToast('message', 'error')  → explicit type

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export function showToast(message: string, type?: ToastType, duration = 3500): void {
  // Auto-detect type from message content if not provided
  if (!type) {
    if (/✅|success|created|updated|saved|sent|archived|restored|recorded|received/i.test(message)) {
      type = 'success';
    } else if (/❌|fail|error|invalid|unable|cannot/i.test(message)) {
      type = 'error';
    } else if (/⚠️|warn|please|required|select|enter/i.test(message)) {
      type = 'warning';
    } else {
      type = 'info';
    }
  }

  const colors: Record<ToastType, string> = {
    success: '#10b981',
    error:   '#ef4444',
    warning: '#f59e0b',
    info:    '#3b82f6',
  };

  // Stack toasts vertically if multiple are shown
  const existing = document.querySelectorAll('[data-shahosuite-toast]');
  const topOffset = 24 + existing.length * 72;

  const div = document.createElement('div');
  div.setAttribute('data-shahosuite-toast', '1');
  div.style.cssText = [
    'position:fixed',
    `top:${topOffset}px`,
    'right:24px',
    'z-index:99999',
    `background:${colors[type]}`,
    'color:#fff',
    'padding:13px 20px',
    'border-radius:10px',
    'font-weight:600',
    'font-size:14px',
    'font-family:inherit',
    'box-shadow:0 4px 20px rgba(0,0,0,0.22)',
    'display:flex',
    'align-items:center',
    'gap:8px',
    'max-width:420px',
    'line-height:1.4',
    'transition:opacity 0.3s ease',
    'cursor:pointer',
  ].join(';');

  div.textContent = message;

  // Click to dismiss early
  div.addEventListener('click', () => dismiss());

  document.body.appendChild(div);

  function dismiss() {
    div.style.opacity = '0';
    setTimeout(() => {
      div.remove();
      // Re-stack remaining toasts
      const remaining = document.querySelectorAll('[data-shahosuite-toast]');
      remaining.forEach((el, i) => {
        (el as HTMLElement).style.top = `${24 + i * 72}px`;
      });
    }, 300);
  }

  setTimeout(dismiss, duration);
}
